<template>
  <div class="recharge-activity-page">
    <div class="recharge-activity">优惠券列表</div>
    <div class="flex-row-start">
      <div class="activity-name">使用时间</div>
      <el-date-picker
        class="mr20"
        v-model="usedTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        @change="dateChange"
      ></el-date-picker>
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    <div class="flex-row-start">
      <div class="pr30">营销统计</div>
      <div class="pr30 bold">
        已使用：<span class="colorblue">{{ usedCount }}</span> 张
      </div>
      <div class="pr30 bold">
        合计：<span class="color-orange">{{
          deductionAmount ? deductionAmount.toFixed(2) : deductionAmount
        }}</span>
        元
      </div>
    </div>
    <div class="table-area">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column align="center" prop="userName" label="用户"></el-table-column>
        <el-table-column align="center" prop="usedTime" label="时间"></el-table-column>
        <el-table-column
          align="center"
          prop="price"
          label="优惠券金额（元）"
        ></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float: right; margin-top: 10px"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { cashCouponUsedDetailList } from "@/api/index";
export default {
  data() {
    return {
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      loading: false,
      usedCount: 0,
      deductionAmount: 0,
      status: "",
      usedTime: "",
      startDate: "",
      endDate: "",
    };
  },
  created() {
    this.cashCouponUsedDetailList();
  },
  methods: {
    dateChange(date) {
      if (!date) {
        this.startDate = null;
        this.endDate = null;
        this.cashCouponUsedDetailList();
        return;
      }
      this.startDate = date[0];
      this.endDate = date[1];
    },
    cashCouponUsedDetailList(startDate, endDate) {
      this.loading = true;
      cashCouponUsedDetailList({
        pageNumber: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        startDate: startDate,
        endDate: endDate,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.usedCount = res.data.statistics.usedCount;
          this.deductionAmount = res.data.statistics.deductionAmount;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.cashCouponUsedDetailList(this.startDate, this.endDate);
      } else {
        this.cashCouponUsedDetailList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.cashCouponUsedDetailList(this.startDate, this.endDate);
    },
  },
};
</script>

<style lang="less" scoped>
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
.mr20 {
  margin-right: 20px;
}
.colorblue {
  color: #3388ff;
}
.recharge-activity-page {
  padding: 30px 20px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 80px);
  overflow-y: scroll;
  .recharge-activity {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 25px 0;
    box-sizing: border-box;
    .activity-name {
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 40px;
    }
    .bold {
      font-weight: bold;
      .color-orange {
        color: #ff7757;
      }
    }
  }
  .table-area {
    padding-top: 25px;
    box-sizing: border-box;
  }
}
/deep/ .el-table th {
  background-color: #f7f8fa;
}
</style>
